<template>
  <div class="h-full flex flex-col">
    <div class="h-8 flex justify-between">
      HEADER...

      <vs-button color="primary" @click="addNewManufactureSettings" class="p-1">
        {{ $t('buttons.add') }}
      </vs-button>
    </div>

    <bds-scroll-area component-class="content-scroll-area specific-height">
      <div class="w-full flex flex-wrap bg-white m-1 py-1 rounded-lg shadow">
        <div v-for="(item, index) in _getLanguageChoices" :key="index" class="w-full md:w-1/3 flex flex-row items-center px-1">
          <i class="flag-icon" :class="item.icon"/>
          <bds-label>
            Preço padrao anilha
          </bds-label>

          <vs-input-number :label="$t(`lists.currency.${item.value}`)" v-model="defaults[item.value]" color="#76bb46" :min="0" size="small" />
        </div>
      </div>

      <div v-for="(manufacturer, index) in manufacturers" :key="index" class="w-full flex flex-col bg-white shadow mt-1 py-2 border rounded-lg">
        <!-- HEADER name and remove -->
        <div class="w-full flex flex-row justify-end border-b border-dark p-1">
          <div class="w-1/4 flex justify-around">
            <div class="w-full">
              #{{ manufacturer.id }} - {{ manufacturer.name }}
            </div>

            <div @click.stop="removeManufacturerSettings(manufacturer)" v-if="false"
                 class="w-10 border border-danger hover:bg-danger p-2 mx-2 text-secondary bg-grey-light rounded-lg flex flex-grow items-center justify-center cursor-pointer">
              <feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" />
            </div>
          </div>
          <div class="w-1/4">
            Preço anilhas
          </div>
          <div class="w-1/4 flex justify-around">
            <div class="w-full"> Modelos de Kits </div>

            <div @click.stop="addNewSubModelKit(manufacturer)"
                 class="w-10 border border-primary hover:bg-primary p-2 mx-2 text-secondary bg-grey-light rounded-lg flex flex-grow items-center justify-center cursor-pointer">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            </div>
          </div>
          <div class="w-1/4 flex justify-around">
            <div class="w-full"> Anilha cor </div>

            <div @click.stop="addNewSleeveColor(manufacturer)"
                 class="w-10 border border-primary hover:bg-primary p-2 mx-2 text-secondary bg-grey-light rounded-lg flex flex-grow items-center justify-center cursor-pointer">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            </div>
          </div>
        </div>

        <!-- body of manufactur box -->
        <div class="flex flex-row">
          <div class="w-1/4 flex flex-col justify-center p-1">
            <bds-label text="Nome da fabricante"/>
            <vs-input v-model="manufacturer.name" class="mb-1" size="small" :disabled="manufacturer.id > 0"/>

            <div class="flex flex-row space-x-2">
              <bds-label text="Ativo?"/>
              <vs-switch v-model="manufacturer.active" />
            </div>
          </div>

          <!-- Sleeve price -->
          <div class="w-1/4 flex flex-col justify-center items-center">
            <div class="flex flex-row space-x-2">
              <bds-label text="valor anilha ($)" />
            </div>

            <div v-for="(m_price, index) in manufacturer.sleeve_price" :key="index" class="flex flex-row space-x-2">
              <i class="flag-icon" :class="m_price.icon"/>
              <vs-input-number :label="$t(`lists.currency.${m_price.currency}`)" v-model="m_price.value" color="#76bb46" :min="0" size="small" />
            </div>
          </div>

          <!-- Kit models -->
          <div class="w-1/4 flex flex-col">
            <div v-for="(system_item, index) in manufacturer.subsystem" :key="index" class="w-full flex flex-row p-1">
              <vs-input v-model="system_item.name" size="small" class="mx-1"/>
              <feather-icon icon="EyeIcon" class="text-primary" svgClasses="h-5 w-5 cursor-pointer" v-if="system_item.active" @click="activeToggleSubSystem(system_item)"/>
              <feather-icon icon="EyeOffIcon" class="text-danger" svgClasses="h-5 w-5 cursor-pointer" v-else @click="activeToggleSubSystem(system_item)"/>
              <feather-icon icon="XIcon" class="text-danger" svgClasses="h-5 w-5 cursor-pointer" @click="removeSubSystem(manufacturer, system_item)" v-if="false"/>
            </div>
          </div>

          <!-- Sleeve colors -->
          <div class="w-1/4 flex flex-col">
            <div v-for="(sleeve_item, index) in manufacturer.sleeve_color" :key="index" class="w-full flex flex-row p-1">
              <vs-input v-model="sleeve_item.name" size="small" class="mx-1"/>
              <feather-icon icon="EyeIcon" class="text-primary" svgClasses="h-5 w-5 cursor-pointer" v-if="sleeve_item.active" @click="activeToggleSleeveColor(sleeve_item)"/>
              <feather-icon icon="EyeOffIcon" class="text-danger" svgClasses="h-5 w-5 cursor-pointer" v-else @click="activeToggleSleeveColor(sleeve_item)"/>
              <feather-icon icon="XIcon" class="text-danger" svgClasses="h-5 w-5 cursor-pointer" @click="removeSleeveColor(manufacturer, sleeve_item)"/>
            </div>
          </div>
        </div>
      </div>
    </bds-scroll-area>

    <div class="h-16 flex justify-around items-center space-x-2">
      <vs-button type="border" color="red" class="h-8 hover:text-white" size="small" @click="cancel">
        {{ $t('buttons.cancel') }}
      </vs-button>
      <vs-button type="border" color="primary" class="h-8 hover:text-white" size="small" @click="save">
        {{ $t('buttons.save') }}
      </vs-button>
    </div>
  </div>
</template>

<script>
import MetadataService from "@/services/Metadata.service";
import { ManufactureMetadata } from "@/models/Metadata.model";
import {showErrorDialog, showSuccessNotify} from "@/helpers/functionsHelpers";
import {getLanguageChoices} from '@/helpers/lists';

export default {
  name: "ManufactureSettings",
  data() {
    return {
      store_manufactures: [],

      defaults: {
        ptBR: 0,
        en: 0,
        es: 0
      }
    }
  },
  watch: {

  },
  computed: {
    manufacturers() {
      return this.store_manufactures;
    },
    _getLanguageChoices() {
      return getLanguageChoices();
    }
  },
  methods: {
    listSleeves() {
      const p_default_price = MetadataService.fetchDefault().then((response) => {
        this.defaults.ptBR = response.ptBR;
        this.defaults.en = response.en;
        this.defaults.es = response.es;
        return Promise.resolve(true);
      }, (error) => {
        showErrorDialog(error);
        return Promise.reject(error);
      });

      const p_manufactures = MetadataService.listManufactures().then((response) => {
        this.store_manufactures = [];
        for (let obj of response) {
          let _m = ManufactureMetadata.FromObj(obj);
          this.store_manufactures.push(_m);
        }
        return Promise.resolve(true);
      }, (error) => {
        showErrorDialog(error);
        return Promise.reject(error);
      });

      return Promise.all([p_manufactures, p_default_price]);
    },
    cancel() {
      this.listSleeves();
    },
    save() {
      const payload = {
        defaults: this.defaults,
        manufacturers: this.manufacturers
      }
      return MetadataService.saveManufactures(payload).then(() => {
        showSuccessNotify(this, 'sucesso');
        return this.listSleeves();
      }, (error) => {
        showErrorDialog(this, error);
        return Promise.reject(error);
      });
    },

    addNewManufactureSettings() {
      let new_item = new ManufactureMetadata();
      this.store_manufactures.push(new_item);
    },
    removeManufacturerSettings(manufacure_item) {
      const index = this.store_manufactures.indexOf(manufacure_item);
      this.store_manufactures.splice(index, 1);
    },

    addNewSubModelKit(manufacturer) {
      manufacturer.addSubsystem('');
    },
    activeToggleSubSystem(system_item) {
      system_item.active = !system_item.active;
    },
    removeSubSystem(manufacturer, system_item) {
      manufacturer.removeSubSystem(system_item);
    },

    addNewSleeveColor(manufacturer) {
      manufacturer.addSleeveColor('');
    },
    activeToggleSleeveColor(sleeve_item) {
      sleeve_item.active = !sleeve_item.active;
    },
    removeSleeveColor(manufacturer, sleeve_item) {
      manufacturer.removeSleeveColor(sleeve_item);
    }
  },
  mounted() {
    this.listSleeves();
  }
}
</script>

<style lang="scss">
  .content-scroll-area{
    margin: 2px;
  }

  .content-scroll-area.specific-height {
    height: calc(100% - 4rem);
  }

  @media screen and (min-width: $screen-md-min) {
    .content-scroll-area.specific-height {
      height: calc(100% - 6rem);
    }
  }
</style>
